import React from "react";

const MergeExerciseModal = ({
  isVisible,
  onClose,
  isRemoveMode = false,
  title,
  mvideo,
  onVideoChange,
  workout,
  selectedExerciseIds,
  selectedExerciseremoveIds,
  mergeId,
  onExerciseClick,
  onExerciseClickRemove,
  onMergeExercises,
  onRemoveMergedExercises,
  formateSetsinputs
}) => {
  if (!isVisible) return null;

  return (
    <div className="excercise-modal">
      <div className="child-modal">
        <div className="add-excersie">
          <span>{title}</span>
          <i className="fa fa-times" onClick={onClose}></i>
        </div>
        
        {!isRemoveMode && (
          <div className="form-group">
            <input
              type="text"
              className="input videoinput"
              placeholder="Add a complex/merger video link"
              value={mvideo}
              onChange={onVideoChange}
            />
          </div>
        )}

        {workout?.merged_exercises_collections?.map((mergedexercise) => (
          <div key={mergedexercise.id} className="merg-container">
            {(!isRemoveMode && mergedexercise?.workout_exercises?.length < 2) ||
            (isRemoveMode && mergedexercise?.id == mergeId && mergedexercise?.workout_exercises?.length > 1) ? (
              mergedexercise?.workout_exercises?.map((exc) =>
                workout?.exercises?.map((exercise) =>
                  exercise.id == exc?.workout_exercise_id ? (
                    <li
                      key={exercise.id}
                      className={`exercise-wrapper ${
                        (!isRemoveMode && selectedExerciseIds.some(
                          (item) => item.workout_exercise_id === exc?.workout_exercise_id
                        )) ||
                        (isRemoveMode && selectedExerciseremoveIds.some(
                          (item) => item.workout_exercise_id === exc?.workout_exercise_id
                        ))
                          ? "selectedmerge"
                          : ""
                      }`}
                      onClick={() =>
                        isRemoveMode
                          ? onExerciseClickRemove(exc?.workout_exercise_id)
                          : onExerciseClick(exc?.workout_exercise_id)
                      }
                    >
                      <div className="icon-wrapper">
                        <div className="icon">
                          {exercise?.name?.substring(0, 2)}
                        </div>
                        <div className="data">
                          <p className="title">{exercise?.name}</p>
                          <p className="subtitle">
                            Sets:
                            {workout?.workout_type === "AMRAP" ? (
                              <span>Max</span>
                            ) : (
                              <span>{exercise?.sets?.length}</span>
                            )}
                            {Object.entries(formateSetsinputs(exercise?.sets)).map(
                              ([fieldName, values]) => (
                                <span key={fieldName} className="valss bluee">
                                  {`${fieldName}: ${values.join("/")} `}
                                  <span className="bluee">
                                    {getFieldUnit(fieldName)}
                                  </span>
                                </span>
                              )
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="video">
                        {exercise?.video !== null && (
                          <a href={exercise?.video} target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-video"></i>
                          </a>
                        )}
                      </div>
                    </li>
                  ) : null
                )
              )
            ) : null}
          </div>
        ))}

        <div className="d-flex justify-content-center">
          {!isRemoveMode ? (
            <button className="button" onClick={onMergeExercises}>
              Merge excercises now
            </button>
          ) : (
            selectedExerciseremoveIds?.length > 0 && (
              <button className="button" onClick={onRemoveMergedExercises}>
                Remove Merged exercises now
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

const getFieldUnit = (fieldName) => {
  const units = {
    "WEIGHT": "kgs",
    "Distance": "meters",
    "CALORIES": "calories",
    "DURATION": "minutes",
    "REPETITIONS": "reps",
    "DISTANCE": "meters",
    "Jump Row": "meters"
  };
  return units[fieldName] || "";
};

export default MergeExerciseModal;
